import PropTypes from 'prop-types';
import React from 'react';
import styled from '@utils/styled-px2rem';

import Tab from '../Tab';

class Tabs extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    const { value } = this.state;
    const tabElement = event.target.closest('li');
    const nextValue =
      tabElement.getAttribute('value') !== '0'
        ? tabElement.getAttribute('value')
        : tabElement.getAttribute('data-value');
    if (!nextValue || nextValue === value) {
      return;
    }

    const { onChange } = this.props;
    this.setState({ value: nextValue }, () => onChange(nextValue));
  }

  render() {
    const {
      className,
      children,
      functional: isFunctional,
      vertical,
    } = this.props;
    const { value } = this.state;

    if (isFunctional) {
      return (
        <ul className={className}>
          {React.Children.map(children, child =>
            React.cloneElement(child, {
              functional: true,
              onClick: this.handleClick,
            })
          )}
        </ul>
      );
    }

    return (
      <StyledTabs className={className} vertical={vertical}>
        {React.Children.map(children, child => (
          <StyledTab
            className={child.props.className}
            component={child}
            onClick={this.handleClick}
            selected={child.props.value === value}
            vertical={vertical}
          />
        ))}
      </StyledTabs>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf([Tab]),
    }).isRequired
  ).isRequired,
  className: PropTypes.string,
  functional: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  vertical: PropTypes.bool,
};

Tabs.defaultProps = {
  className: '',
  functional: false,
  onChange: Function.prototype,
  value: null,
  vertical: false,
};

const StyledTabs = styled.ul`
  ${props =>
    !props.vertical &&
    `
    height: 100px;
    padding-bottom: 12px;
  `}

  ${props =>
    props.vertical &&
    `
    padding-right: 12px;
    width: 300px;
  `}
`;

const StyledTab = styled(({ component, ...props }) =>
  React.cloneElement(component, props)
)`
  ${props =>
    !props.vertical &&
    `
    float: left;
    height: 100%;
    margin-bottom: 10px;
    
    & + & {
      margin-left: 5px;
    }
  `}

  ${props =>
    props.vertical &&
    `
    margin-right: 10px;
    width: 100%;
  
    & + & {
      margin-top: 5px;
    }
  `}

  ${props =>
    !props.vertical &&
    props.selected &&
    `
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin-bottom: 0;
    padding-bottom: 10px;
  `}
  
  ${props =>
    props.vertical &&
    props.selected &&
    `
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: 0;
    padding-right: 10px;
  `}
`;

export default Tabs;
